import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

import Loader from "../../components/loader";
import api from "../../services/api";

export default function List() {
  const [contracts, setContracts] = useState();
  const [search, setSearch] = useState("");
  const { businessUnit } = useSelector((state) => state.Auth);
  const navigate = useNavigate();

  useEffect(() => {
    fetchContracts();
  }, [search, businessUnit._id]);

  const fetchContracts = async () => {
    const query = {};
    if (search) query.search = search;
    if (businessUnit._id !== "ALL") query.business_unit_id = businessUnit._id;
    const { data, ok } = await api.post("/legal_document/search", query);
    if (!ok) return toast.error("Failed to load contracts");
    setContracts(data);
  };

  if (!contracts) return <Loader size="small" />;

  return (
    <div>
      <div className="flex items-center justify-between mb-3 gap-3">
        <p>{contracts.length} contract{contracts.length !== 1 ? "s" : ""}</p>
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by name, project or user..."
          className="flex-1 max-w-sm border border-gray-300 rounded px-2 py-1 text-sm"
        />
      </div>
      <div className="bg-white rounded-lg">
        <table className="min-w-full divide-y divide-gray-200 table-fixed">
          <thead>
            <tr className="border-b border-gray-300">
              <th className="px-4 py-3 text-xs font-bold text-left text-gray-500 uppercase">Name</th>
              <th className="px-4 py-3 text-xs font-bold text-left text-gray-500 uppercase">Template</th>
              <th className="px-4 py-3 text-xs font-bold text-left text-gray-500 uppercase">Project</th>
              <th className="px-4 py-3 text-xs font-bold text-left text-gray-500 uppercase">User</th>
              <th className="px-4 py-3 text-xs font-bold text-left text-gray-500 uppercase">BU</th>
              <th className="px-4 py-3 text-xs font-bold text-left text-gray-500 uppercase">Budget</th>
              <th className="px-4 py-3 text-xs font-bold text-left text-gray-500 uppercase">Created</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {contracts.length === 0 ? (
              <tr>
                <td colSpan={7} className="px-4 py-4 text-sm text-center text-gray-400">No contracts found</td>
              </tr>
            ) : (
              contracts.map((c) => (
                <tr key={c._id} className="hover:bg-blue-50 cursor-pointer" onClick={() => navigate(`/legal_document/${c._id}`)}>
                  <td className="px-4 py-2 text-sm font-medium text-gray-600">{c.name || "Untitled"}</td>
                  <td className="px-4 py-2 text-sm text-gray-500">{c.templateName || "-"}</td>
                  <td className="px-4 py-2 text-sm text-gray-500">{c.projectName || "-"}</td>
                  <td className="px-4 py-2 text-sm text-gray-500">{c.userName || "-"}</td>
                  <td className="px-4 py-2 text-sm text-gray-500">{c.business_unit_name || "-"}</td>
                  <td className="px-4 py-2 text-sm text-gray-500">{c.budgetName || "-"}</td>
                  <td className="px-4 py-2 text-sm text-gray-500">{new Date(c.created_at).toLocaleDateString()}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
